import { useFormikContext } from "formik";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import { Col } from "react-bootstrap";

const { userFullName, errorMessageToast } = require("helpers/common")
const { AppSelect2Field } = require("../FormComponents/AppSelect2Field")

const ApprenticeSelect = ({ name = "student", caseApprentice, previewMode }) => {
  const { setFieldValue, values } = useFormikContext();
  const apprenticeOption = useMemo(() => caseApprentice?.caseTherapist?.id ? [{ label: userFullName(caseApprentice?.caseTherapist), value: caseApprentice?.caseTherapist?.id }] : [], [caseApprentice]);
  

  return (
    <div className="d-flex gap-2 mt-2 align-items-center">
      <input
        type="checkbox"
        className="form-check"
        style={{ accentColor: "#b46c9f", height: 20, width: 20 }}
        disabled={previewMode}
        onChange={(e) => {
          if (values?.student?.value) {
            setFieldValue('apprentice_id', e.target.checked ? caseApprentice?.caseTherapist?.id : null);
          }
          else {
            errorMessageToast("Please select the apprentice")
          }
        }}
        checked={values.apprentice_id === caseApprentice?.caseTherapist?.id}
      />
      <div className="d-flex student-cstm-select flex-1 w-100 gap-2 align-items-center">
        <span className="proxima" style={{ fontSize: "14px" }}>Add Student:</span>
        <Col md='4'>
          <AppSelect2Field
            name={name}
            option={apprenticeOption}
            placeholder="Select a student..."
            classNamePrefix="khan"
            // onChange={(selected) => {
            //   console.log("selected", selected);
            // }}
          />
        </Col>
      </div>
    </div>
  )
}

export default ApprenticeSelect;